$(document).ready(function() {

  $(".complete-the-look__products .ctl-product:lt(3)").css("display", "flex");
  

  $('.ctl-product__info-variant select').on('change', function() {
    var product = $(this).parents('.ctl-product__container');
    var price = product.find('.ctl-product__info-price p');
    var imagen = product.find('.ctl-product__image img');
    var selectedOption = $(this).find('option:selected');
    var dataPrice = selectedOption.data('price');
    var dataImagen = selectedOption.data('imagen');

    price.text(dataPrice);

    if(dataImagen){
      imagen.attr('src',dataImagen);
    }
    
  });


  $(document).on('click', 'button.ctl-product__addToCart', function() {
      var $button = $(this);
      var $select = $button.parents('.ctl-product__info').find('.ctl-product__info-variant select');
      var $id = $select.val();
  
      var productData = {
          items: [
              {
                id: $id,
                quantity: 1
              }
          ]
      };
  
      $button.text('Adding...');
  
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: productData,
          dataType: 'json',
          success: function(response) {
              $button.text('Added!');
              setTimeout(function() {
                  $button.text("Add To Cart");
              }, 1000);
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
              console.log('Error al agregar el producto al carrito');
          }
      });
  });

  
});